import Component from "@glimmer/component"

export default class KbHeader extends Component {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Kb::Header": typeof KbHeader
  }
}
